var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { BaseNotification } from "./base-notification";
import { AllEntityTypeConfigurationConstants } from "../../../../models/basics/basics.models";
var WorkflowNotification = /** @class */ (function (_super) {
    __extends(WorkflowNotification, _super);
    function WorkflowNotification(router) {
        var _this = _super.call(this) || this;
        _this.router = router;
        return _this;
    }
    WorkflowNotification.prototype.viewWorkFlow = function ($event) {
        var data = {};
        if (this.notification && this.notification.dataJson) {
            data = JSON.parse(this.notification.dataJson);
        }
        var entity = AllEntityTypeConfigurationConstants.filter(function (x) { return x.entityType == data.entityTypeId; })[0];
        if (!entity || !data)
            return;
        this.router.navigateToRoute(entity.editRoute, { id: data.entityId, source: 'workflowNotification' });
        if (this.notificationCenter) {
            this.notificationCenter.togglePanel($event);
        }
    };
    WorkflowNotification = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Router])
    ], WorkflowNotification);
    return WorkflowNotification;
}(BaseNotification));
export { WorkflowNotification };
